import mock from 'api/mockFastApi';
import {base64pdf} from './data';

mock.onPost('/weasyprint/render-pdf-base64').reply(() => [200, base64pdf]);
